import {
  ClientContentWrapper,
  ClientInfosWrapper,
  ClientLeftData,
  ClientRightData,
  DisplayLess,
  ClientContentMobileWrapper,
  ClientDataMobile,
  StatusWrapper
} from './styles'
import { useTranslation } from 'react-i18next'
import ClientBaseInfos from 'pages/ClientDetails/components/ClientBaseInfos'
import ClientInfos from 'pages/ClientDetails/components/ClientInfos'
import ClientStatus from 'components/ClientStatus'
import { Link } from 'react-router-dom'
import ClientTabs from 'pages/ClientDetails/components/ClientTabs'
import { isMobile } from 'react-device-detect'
import { Domiciliation } from 'globals/models/Domiciliation'
import { ArrowUp } from 'components/Icons'

interface IProps {
  domiciliation: Domiciliation
}

const ClientContent = (props: IProps) => {
  const { domiciliation } = props
  const { t } = useTranslation()

  return (
    <>
      {!isMobile ? (
        <>
          <ClientInfosWrapper>
            <ClientLeftData>
              <ClientBaseInfos domiciliation={domiciliation} />
            </ClientLeftData>
            <ClientRightData>
              <ClientInfos domiciliation={domiciliation} />
            </ClientRightData>
          </ClientInfosWrapper>

          <ClientContentWrapper>
            <ClientTabs domiciliation={domiciliation} />
          </ClientContentWrapper>
        </>
      ) : (
        <ClientContentMobileWrapper>
          <ClientDataMobile>
            <StatusWrapper>
              <ClientStatus status={domiciliation.status} />
            </StatusWrapper>

            <ClientBaseInfos domiciliation={domiciliation} />

            <ClientTabs domiciliation={domiciliation} />
          </ClientDataMobile>

          <DisplayLess>
            <Link to='/clients'>
              <span>{t('clients.less')}</span>
              <ArrowUp />
            </Link>
          </DisplayLess>
        </ClientContentMobileWrapper>
      )}
    </>
  )
}

export default ClientContent
